export const SHORT_DESCRIPTION_MAX_LENGTH = 16384;
